import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Home, Book, Gamepad2, Settings, GraduationCap, MessageCircle } from "lucide-react";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Home", icon: <Home className="w-5 h-5" /> },
    { to: "/lessons", label: "Lessons", icon: <GraduationCap className="w-5 h-5" /> },
    { to: "/blog", label: "Blog", icon: <Book className="w-5 h-5" /> },
    { to: "/activities", label: "Activities", icon: <Gamepad2 className="w-5 h-5" /> },
    { to: "/reviews", label: "Reviews", icon: <MessageCircle className="w-5 h-5" /> },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-glass sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_farm-tales-store/artifacts/kyjajpew_1000080225%20%281%29.png" 
              alt="FarmSmartKids Logo" 
              className="w-14 h-14 rounded-2xl border-4 border-[#1D3557] object-cover"
            />
            <span className="text-xl font-black text-[#1D3557] hidden sm:block" style={{ fontFamily: "'Fredoka', sans-serif" }}>
              FarmSmartKids
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-5 py-2.5 rounded-xl font-bold transition-all flex items-center gap-2 border-3 ${
                  isActive(link.to)
                    ? "bg-[#E63946] text-white border-[#1D3557] shadow-[3px_3px_0px_0px_rgba(29,53,87,1)]"
                    : "text-[#1D3557] border-transparent hover:bg-[#E9C46A]/30"
                }`}
                style={{ fontFamily: "'Fredoka', sans-serif" }}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.icon}
                {link.label}
              </Link>
            ))}
            <Link
              to="/admin"
              className="ml-4 px-5 py-2.5 rounded-xl font-bold text-[#1D3557] border-3 border-[#1D3557] hover:bg-[#1D3557] hover:text-white transition-all flex items-center gap-2"
              style={{ fontFamily: "'Fredoka', sans-serif" }}
              data-testid="nav-admin"
            >
              <Settings className="w-5 h-5" />
              Admin
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-[#1D3557]"
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden pb-6 border-t-4 border-[#1D3557]/10 pt-4">
            <div className="space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`block px-5 py-3 rounded-xl font-bold transition-all flex items-center gap-3 ${
                    isActive(link.to)
                      ? "bg-[#E63946] text-white"
                      : "text-[#1D3557] hover:bg-[#E9C46A]/30"
                  }`}
                  style={{ fontFamily: "'Fredoka', sans-serif" }}
                >
                  {link.icon}
                  {link.label}
                </Link>
              ))}
              <Link
                to="/admin"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-5 py-3 rounded-xl font-bold text-[#1D3557] border-3 border-[#1D3557] hover:bg-[#1D3557] hover:text-white transition-all flex items-center gap-3"
                style={{ fontFamily: "'Fredoka', sans-serif" }}
              >
                <Settings className="w-5 h-5" />
                Admin
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
